import { useEffect, useState } from "react";

const navItems = [
  { label: "题材细分", href: "#genres" },
  { label: "分级尺度", href: "#rating" },
  { label: "代表作品", href: "#works" },
  { label: "版本差异", href: "#uncut" },
  { label: "人性母题", href: "#nature" },
  { label: "观影指引", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[72px] flex items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 group">
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
                solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50 border border-background-50/30"
              }`}
            >
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-base md:text-lg font-semibold tracking-wide transition-colors ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                欧美伦理电影
              </span>
              <span
                className={`font-label text-[10px] tracking-[0.18em] mt-0.5 transition-colors ${
                  solid ? "text-foreground-500" : "text-background-50/70"
                }`}
              >
                题材 · 尺度 · 人性
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`font-label text-sm whitespace-nowrap transition-colors ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/85 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#works"
            className={`hidden lg:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            浏览作品
            <i className="ri-arrow-right-line text-base"></i>
          </a>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 md:px-8 py-4 flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 font-label text-sm text-foreground-700 border-b border-background-100 last:border-none hover:text-primary-600 transition-colors"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#works"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap"
            >
              浏览代表作品
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}